const Loader = () => {
	return (
		<div className=" ">
			<span className="base-loader"></span>
		</div>
	);
};

export default Loader;
